import { Admin, DashUser } from "@/router";
export default [
    {
        title: "الرئيسية",
        route: "/admin/home",
        icon: "home-alt",
        roles: [Admin, DashUser]
    },
    {
        title: "المستخدمين",
        route: "/admin/user",
        icon: "users-alt",
        roles: [Admin, DashUser]
    }
];
